export const global_height_breakpoint_lg = {
  "name": "--pf-global--height-breakpoint--lg",
  "value": "48rem",
  "var": "var(--pf-global--height-breakpoint--lg)"
};
export default global_height_breakpoint_lg;